import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { addCrudCases } from '../../store/addCrudCases';
import { messageThunks, analyzeMessage, fetchMessageSummary } from './messageThunks';
import type { MessageState } from './messageTypes';

const initialState: MessageState = {
  items: [],
  byId: {},
  currentItem: null,
  status: 'idle',
  error: null,
  selectedMessageId: null,
  aiAnalysis: null,
  totalCount: 0,
  summariesById: {},
};

export const messageSlice = createSlice({
  name: 'messages',
  initialState,
  reducers: {
    selectMessage(state, action: PayloadAction<number | null>) {
      state.selectedMessageId = action.payload;
      state.aiAnalysis = null;
    },
  },
  extraReducers: (builder) => {
    addCrudCases(builder, messageThunks, (m) => m.messageId);
    // Proiezioni leggere (timeline attività): cache separata da byId, popolata on-demand.
    builder.addCase(fetchMessageSummary.fulfilled, (state, action) => {
      state.summariesById[action.payload.messageId] = action.payload;
    });
    builder
      .addCase(analyzeMessage.pending, (state) => {
        state.aiAnalysis = { suggestedNextStep: '', status: 'loading' };
      })
      .addCase(analyzeMessage.fulfilled, (state, action) => {
        state.aiAnalysis = { ...action.payload, status: 'succeeded' };
      })
      .addCase(analyzeMessage.rejected, (state) => {
        if (state.aiAnalysis) state.aiAnalysis.status = 'failed';
      });
    // NB: updateMessageInfo.fulfilled non ha extraReducer: l'inbox non
    // legge `state.messages.items` (usa useServerPagedSearch), quindi
    // ogni mutazione qui sarebbe no-op. Il thunk ritorna il MessageInfo
    // fresco via .unwrap() e il MessageInbox aggiorna direttamente il
    // proprio local state via patchMessage. Non riaggiungere questo
    // reducer senza prima allineare l'inbox a leggere da Redux.
  },
});

export const { selectMessage } = messageSlice.actions;
export const messageReducer = messageSlice.reducer;
